import React, { useContext, useState, useEffect } from 'react'
import DashboardLayout from '../DashboardLayout'
import { Button } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'
import NoRecordsFound from '@/custom/components/atoms/NoRecordsFound'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/custom/components/organisms/Dialog'
import ProductContext from '@/product/context/product/productContext'
import AuthContext from '@/product/context/auth/authContext'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { dateTimeFormatFunction, mapData } from '@/product/common/components'
import SEO from '@/utils/SEO'

const SavedSearchBody = (props) => {
    const productContext = useContext(ProductContext)
    const authContext = useContext(AuthContext)
    const [toggleDialog, setToggleDialog] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const [currentID, setCurrentID] = useState(0)
    const [record, setRecord] = useState([])
    const [limit, setLimit] = useState('10')
    const [editDialog, setEditDialog] = useState(false)

    const { isAuthenticated } = authContext

    const { responseStatus, getSavedSearch, saved_searches, removeSavedSearch, addSavedSearch } =
        productContext

    useEffect(() => {
        if (saved_searches) {
            /*if (responseStatus.from === 'saved_search' && responseStatus.data) {*/
            setRecord(saved_searches.records || [])
            setTotalPage(saved_searches.totalRecords || 0)
            // setRecord(responseStatus.data.records)
            // setTotalPage(responseStatus.data.totalRecords)
            // }
        }
    }, [saved_searches])

    const loadTable = (page = currentPage) => {
        getSavedSearch({ page: page, limit: limit, orderby: 'ss.id,DESC' })
    }

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'saved_search_msg') {
                if (responseStatus.status === 'success') {
                    loadTable()
                }
            }
        }
    }, [responseStatus])

    const changeEditDialogStatus = () => {
        setEditDialog(!editDialog)
        resetForm()
    }

    const removeRecord = (id) => {
        removeSavedSearch({ id })
        loadTable()
        setToggleDialog(false)
    }

    useEffect(() => {
        if (isAuthenticated) {
            loadTable()
        }
    }, [isAuthenticated])

    const onHandlePage = async (event, value) => {
        setCurrentPage(value)
        loadTable(value)
    }

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    const pageOptions = [
        {
            value: '10',
            show: '10',
        },
        {
            value: '24',
            show: '24',
        },
        {
            value: '36',
            show: '36',
        },
    ]

    const sortShow = [
        {
            value: '',
            show: 'Sort By',
        },
    ]

    const validationArray = Yup.object({
        search_text: Yup.string().required('Title is required feild'),
    })

    const formikSelection = useFormik({
        initialValues: {
            id: 0,
            // category: [],
            search_text: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            addSavedSearch(values)
            resetForm()
            setEditDialog(false)
        },
    })

    const updateId = (data) => {
        formikSelection.values.id = data.id
        formikSelection.values.search_text = data.search_text
        // formikSelection.values.category = data.category ? data.category.split(',') : []
    }

    const handleChange = (e) => {
        setLimit(e.target.value)
        getSavedSearch({ page: 1, limit: e.target.value, orderby: 'ss.id,DESC' })
    }

    const resetForm = () => {
        formikSelection.values.id = ''
        formikSelection.values.search_text = ''
        // formikSelection.values.category = []
        formikSelection.handleReset()
    }

    const searchBody = {
        formik: formikSelection,
        data: [
            {
                label: 'Title',
                type: 'text',
                placeholder: 'Enter the title',
                class: 'col-12',
                name: 'search_text',
            },
            // {
            //     label: 'Select Category',
            //     type: 'multiselect',
            //     placeholder: 'Select Category',
            //     class: 'col-12',
            //     options: category,
            //     name: 'category',
            // },
        ],
    }

    const closeFunction = () => {
        setEditDialog(false)
        resetForm()
    }

    return (
        <div className="dashboardInner">
            <SEO title="My Saved Searches" url={window.location.href} />
            <div className="searchMiscFilters w-100 mb-3 d-flex justify-content-between align-items-center mt-4 ss-filters">
                <h1 className="title mb-3 text-center">SAVED SEARCH</h1>
                <div className="savedschBtn d-flex justify-content-start align-items-center">
                    <PrimaryButton
                        id="savedsearch_add_card"
                        onClick={() => {
                            setEditDialog(true)
                        }}
                        variant="outlined"
                    >
                        {'Add New +'}
                    </PrimaryButton>
                </div>
            </div>
            {record.length ? (
                <>
                    <div className="table-responsive dpTable">
                        <table className="table text-left">
                            <thead>
                                <tr>
                                    {/*<th scope="col">{'S_no'}</th>*/}
                                    <th scope="col">{'Title'}</th>
                                    <th scope="col" className="text-center">
                                        {'Date Added'}
                                    </th>
                                    <th scope="col" className="text-center">
                                        {'Action'}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {record.map((data, index) => (
                                    <tr key={`saved_${index}`}>
                                        {/*<td>{index + 1}</td> */}
                                        <td>{data.search_text}</td>
                                        <td className="text-center">
                                            {dateTimeFormatFunction(data.created_at)}
                                        </td>
                                        <td className="text-center">
                                            <div className="d-flex ssActBtn ss-btns-wraps justify-content-center">
                                                <Button
                                                    id="open_in_new"
                                                    onClick={() => {
                                                        updateId(data)
                                                        setEditDialog(true)
                                                    }}
                                                >
                                                    <span className="material-icons">edit</span>
                                                </Button>
                                                <Button
                                                    id="savedSearch_delete"
                                                    onClick={() => {
                                                        setCurrentID(data.id)
                                                        setToggleDialog(true)
                                                    }}
                                                >
                                                    <span className="material-icons outlined">
                                                        delete
                                                    </span>
                                                </Button>
                                                <PrimaryButton
                                                    id="open_in_new"
                                                    onClick={() =>
                                                        props.getSearchBarObjet(data.search_text)
                                                    }
                                                >
                                                    View
                                                </PrimaryButton>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div
                        className="d-flex align-items-center ss-pagination-wrap"
                        style={{ gap: '8px' }}
                    >
                        <Pagination
                            count={Math.ceil(totalPage / limit)}
                            page={currentPage}
                            onChange={onHandlePage}
                            siblingCount={3}
                            showFirstButton
                            showLastButton
                            boundaryCount={2}
                        />
                        <div className="resultsCnt ml-auto">
                            <label className="rpp-label">Results per page</label>
                            <CustomSelect
                                label=""
                                name="resultsPerPage"
                                selectType="noBorder"
                                value={limit}
                                size="small"
                                onChange={handleChange}
                            >
                                {pageOptions.map((opt, optindex) => (
                                    <option value={opt.value}>{opt.show}</option>
                                ))}
                            </CustomSelect>
                        </div>

                        {/* <CustomSelect
                            label=""
                            value=""
                            size="small"
                            selectType="noBorder"
                            name="orderby"
                        >
                            {sortShow.map((opt, optindex) => (
                                <option value={opt.value}>{opt.show}</option>
                            ))}
                        </CustomSelect> */}
                    </div>
                </>
            ) : (
                <NoRecordsFound
                    showText={`You currently do not have any saved searches. Click "Add" to save a search for items you're interested in, and we will notify you when listings that match your criteria become available.`}
                />
            )}

            <CustomDialog
                title={'Confirm delete'}
                open={toggleDialog}
                function={changeDialogStatus}
            >
                <h5>{'You are about to delete this saved search'}</h5>
                <h5>{'Please confirm if you want to continue with this action'}</h5>
                <div className="actionWrapper">
                    <Button id="no_cancel" onClick={() => setToggleDialog(false)}>
                        {'No cancel'}
                    </Button>
                    <PrimaryButton
                        id="yes_delete"
                        type="button"
                        onClick={() => removeRecord(currentID)}
                        label={'Yes delete'}
                    />
                </div>
            </CustomDialog>
            <CustomDialog
                title={`${formikSelection.values.id ? 'Edit saved search' : 'Add saved search'}`}
                open={editDialog}
                function={changeEditDialogStatus}
                // disableBackdropClick
            >
                <div className="row">{mapData(searchBody)}</div>
                <div className="actionWrapper flex-row" style={{ gap: '20px' }}>
                    <Button id="no_cancel" onClick={() => closeFunction()}>
                        {'Cancel'}
                    </Button>
                    <PrimaryButton
                        id="category_submit"
                        type="button"
                        onClick={() => formikSelection.handleSubmit()}
                        label={`${formikSelection.values.id ? 'Update' : 'Submit'}`}
                    />
                </div>
            </CustomDialog>
        </div>
    )
}

export default SavedSearchBody
